import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  inject
} from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { PermissionsService } from '../../services/permission.service';
import { ApiService } from '../../services/api.service';
import { SiblingSignalService } from '../../services/submenudatasharing.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class SidebarComponent implements OnInit {

  private siblingBus = inject(SiblingSignalService);

  /* ================= INPUTS ================= */

  @Input() sidebarMode: 'narrow' | 'expanded' | 'hidden' = 'expanded';
  @Input() isHovering: boolean = false;

  /* ================= OUTPUTS ================= */

  @Output() hoverChange = new EventEmitter<boolean>();
  @Output() menuWithSubItemsClicked = new EventEmitter<{menuItem: any[], index: number}>();
  @Output() menuWithoutSubItemsClicked = new EventEmitter<void>();

  /* ================= VARIABLES ================= */

  user = {
    f_name: sessionStorage.getItem('first_name'),
    login_name: sessionStorage.getItem('login_name'),
    l_name: sessionStorage.getItem('last_name'),
    role: sessionStorage.getItem('user_role_name')
  };

  originalMenuItems: any[] = [];
  activeSubmenuIndex: any;
  activeUrl: string | null = null;

  constructor(
    public router: Router,
    private permissionService: PermissionsService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {

   const roleId = sessionStorage.getItem('user_role_id');
   console.log("roleId",roleId);
   

if (roleId) {
  this.apiService
    .getAPI(`/access/get-permissions/?role_id=${roleId}`)
    .subscribe((res: any) => {
      const eventHistoryMenu = {
        id: 'event-history',
        name: 'Event History',
        url: '/event-history',
        scheme_id: null,
        sub_menus: [],
        privileges: [{ status: true }]
      };

      res = Array.isArray(res) ? [...res, eventHistoryMenu] : [eventHistoryMenu];
      this.permissionService.setPermissions(res);
      this.originalMenuItems = res;
    });
} else {
  console.warn('Role ID is null, API not called');
}

    const saved = localStorage.getItem('activeSubmenuIndex');
    if (saved) {
      this.activeSubmenuIndex = JSON.parse(saved);
    }
  }

  /* ================= HOVER ================= */

  onSidebarHover(val: boolean) {
    this.isHovering = val;
    this.hoverChange.emit(val);
  }

  /* ================= MENU CLICK ================= */

  onMenuItemClick(item: any): void {

    this.activeSubmenuIndex = item;
    this.activeUrl = item.url || null;

    localStorage.setItem(
      'activeSubmenuIndex',
      JSON.stringify(item)
    );

    this.router.navigate([item.url], {
      queryParams: { scheme_id: item?.scheme_id }
    });

    if (item.sub_menus?.length) {
      this.menuWithSubItemsClicked.emit({
        menuItem: item.sub_menus,
        index: 0
      });
      item.id !== 15 ? this.siblingBus.emitData(item.sub_menus): this.siblingBus.emitData([]);
      // console.log('conikxnwkdjwd jsnnkamaksm---------------',item)
    } else {
      this.menuWithoutSubItemsClicked.emit();
      this.siblingBus.clear();
    }
  }

  checkPermission(privileges: any[]): boolean {
    return privileges?.some((p: any) => p.status === true);
  }

  @Output() toggleRequested = new EventEmitter<void>();

  toggleSidebar() {
    this.toggleRequested.emit();
  }
  

}
